import React from "react";
import { FaCommentDots, FaQuoteLeft } from "react-icons/fa";

const DirectorMessagePage = () => {
  return (
    <div className="relative bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] min-h-screen overflow-hidden">
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#1298b5]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
      <div className="absolute top-40 right-10 w-72 h-72 bg-[#f97316]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12 animate-fadeInDown">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#1298b5] to-[#0b819b] rounded-2xl text-white mb-5 shadow-lg">
            <FaCommentDots className="text-3xl" />
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-[#073b4c] mb-3">
            Director's <span className="text-[#1298b5]">Message</span>
          </h1>

          <div className="w-24 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded-full"></div>
        </div>

        <div className="bg-white/95 rounded-3xl shadow-2xl p-7 md:p-12 max-w-5xl mx-auto border border-[#d8f4f8] animate-fadeInUp animation-delay-300 mb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
            <div className="flex flex-col items-center md:items-start">
              <div className="relative mb-5">
                <div className="w-48 h-48 md:w-64 md:h-64 rounded-full overflow-hidden border-4 border-[#1298b5] shadow-xl">
                  <img
                    src="image.jpeg"
                    alt="Director"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://via.placeholder.com/300x300?text=Director";
                    }}
                  />
                </div>

                <div className="absolute -bottom-2 -right-2 bg-[#f97316] text-white p-3 rounded-full shadow-lg">
                  <FaQuoteLeft className="text-xl" />
                </div>
              </div>

              <div className="text-center md:text-left">
                <p className="text-[#073b4c] font-bold text-lg">
                  Mr. Pradeep Khairwar
                </p>
                <p className="text-[#1298b5] font-semibold text-sm">
                  Founder & Director
                </p>
                <p className="text-gray-500 text-sm">
                  Aabharan Foundation
                </p>
              </div>
            </div>

            <div className="text-gray-700">
              <h2 className="text-3xl font-extrabold text-[#073b4c] mb-5 leading-tight">
                “A Promise of Dignity, A Legacy of Growth”
              </h2>

              <div className="w-16 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] rounded-full mb-6"></div>

              <p className="mb-4 leading-relaxed">
                The journey of Aabharan Foundation began with a simple
                observation: charity provides a meal for a day, but empowerment
                provides a future for a lifetime. I believe that every
                individual carries an inherent 'Aabharan'—an internal jewel of
                potential—that often remains hidden due to a lack of resources
                or information.
              </p>

              <p className="mb-4 leading-relaxed">
                Our foundation isn't just an NGO; it is a movement to restore
                that dignity. Whether it is a mother in a village earning her
                first income through Aabharan Shakti, or a student gaining the
                confidence to enter the professional world through Yuva Utkarsh,
                we are here to provide the scaffolding.
              </p>

              <p className="mb-4 leading-relaxed">
                Perhaps most dear to my heart is Ankuran Bandhan, where we
                celebrate a new life by planting a green legacy. By linking a
                child's name to a tree, we aren't just fighting climate change;
                we are teaching the next generation that they are the guardians
                of this Earth.
              </p>

              <p className="leading-relaxed font-semibold text-[#073b4c]">
                I invite you to join us. Let us not just dream of a better
                India; let us plant the seeds, train the hands, and enlighten
                the minds to build it together.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white/95 rounded-3xl shadow-2xl p-7 md:p-10 max-w-3xl mx-auto border border-[#d8f4f8] animate-fadeInUp animation-delay-500">
          <h2 className="text-3xl font-extrabold text-[#073b4c] mb-2 text-center">
            Send us a message
          </h2>

          <p className="text-gray-500 text-center mb-8">
            We'll get back to you within 24 hours
          </p>

          <form className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition"
              />

              <input
                type="email"
                placeholder="Email Address"
                className="w-full px-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition"
              />
            </div>

            <textarea
              rows="4"
              placeholder="Your Message"
              className="w-full px-4 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none transition"
            ></textarea>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#1298b5] to-[#0b819b] hover:from-[#f97316] hover:to-[#fb923c] text-white py-3 rounded-xl font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            >
              <FaCommentDots /> Send Message
            </button>
          </form>
        </div>

        <div className="mt-16 text-center text-gray-600 text-sm">
          <p>
            You can also reach us at{" "}
            <span className="font-semibold text-[#1298b5]">
              directors@aabharan.org
            </span>{" "}
            or call{" "}
            <span className="font-semibold text-[#1298b5]">
              +918318700018
            </span>
          </p>

          <p className="mt-2">
            📍 NAIBAZAR, DURGA PUJA RD, CHANDAULI, UP - 232108
          </p>
        </div>
      </div>

      <style>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.08); }
          66% { transform: translate(-20px, 20px) scale(0.95); }
          100% { transform: translate(0px, 0px) scale(1); }
        }

        .animate-blob {
          animation: blob 7s infinite;
        }

        .animation-delay-2000 {
          animation-delay: 2s;
        }

        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInDown {
          animation: fadeInDown 0.8s ease-out forwards;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
        }

        .animation-delay-300 {
          animation-delay: 0.3s;
        }

        .animation-delay-500 {
          animation-delay: 0.5s;
        }
      `}</style>
    </div>
  );
};

export default DirectorMessagePage;